<div class="close-icon" mat-button (click)="dialogRef.close()"></div>

<div mat-dialog-content style="margin-top: 40px;">
  <mat-form-field>
    <mat-select [(ngModel)]="templateId" placeholder="Select Template">
      <mat-option [value]="0">No Template</mat-option>
      <mat-option *ngFor="let item of templates" [value]="item.auditId">{{item.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          (click)="create()"
          style="border-radius: 6px;">
    Create
  </button>
</div>
